import React from 'react'
import GloHero from '../Components/glokode/GloHero'
import ProductOverview from '../Components/glokode/ProductOverview'
import CoreCapabilities from '../Components/glokode/CoreCapabilities'
import WhyGlodesk from '../Components/glokode/WhyGlodesk'
import CollaborateSection from '../Components/glokode/CollaborateSection'
import WhoHero from '../Components/who/WhoHero'

import { Helmet } from "react-helmet-async";
import ContactSection from '../Components/home/ContactSection'

function GloKodeDummy() {
  return (
    <div>
      <Helmet>
    <title>
        GloKode | Business Process Automation & Digital Solutions | Mobikode
    </title>

    <meta
        name="description"
        content="GloKode helps businesses simplify processes, automate routine tasks, improve operational efficiency, and make better decisions with smart digital solutions from Mobikode."
    />

    <meta
        name="keywords"
        content="GloKode, GloKode Software, Business Process Automation, Business Automation Solutions, Process Automation Software, Workflow Automation, Digital Business Solutions, Business Process Management, Business Process Optimization, Task Automation, Workflow Management, Business Efficiency Solutions, Digital Transformation Solutions, Business Automation Platform, Enterprise Automation"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/glokode"
    />

    <meta
        property="og:title"
        content="GloKode | Business Process Automation & Digital Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Simplify business processes, automate routine work, and enable better decision-making with GloKode's smart digital solutions from Mobikode."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/glokode"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="GloKode | Business Process Automation & Digital Solutions | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Make work easier with GloKode by simplifying processes, automating routine tasks, and helping teams make better decisions with greater clarity."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />
</Helmet>
      <WhoHero
        title="Glokode"
        text="Make your work easier by simplifying processes, automating routine tasks, and helping your team make better decisions with less effort and more clarity."
        imgData="/assets/glodesk/bg2.png"
      />
      {/* <GloHero /> */}
      <ProductOverview />
      <CoreCapabilities />
      <WhyGlodesk />
      <ContactSection />
      {/* <CollaborateSection /> */}
    </div>
  )
}

export default GloKodeDummy
